import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";
import { Empty } from "@/components/PageHeader";
import { RichText } from "@/components/RichEditor";
import { ShareButtons } from "@/components/Social";
import { api, fileUrl, fmtDate } from "@/lib/api";

export const Allegato = ({ href, nome, testid }) => (
  <a href={href} target="_blank" rel="noreferrer" data-testid={testid}
    className="mt-6 inline-flex items-center gap-3 border border-slate-200 bg-white rounded-xl px-4 py-3 hover:border-emerald-400 hover:shadow-sm transition-[border-color,box-shadow]">
    <FileText className="h-6 w-6 text-red-600" />
    <span><span className="block text-sm font-medium text-[#0B192C]">{nome || "Allegato PDF"}</span><span className="text-xs text-muted-foreground">Apri il PDF</span></span>
  </a>
);

export default function NewsDetail({ publico = false }) {
  const { id } = useParams();
  const [n, setN] = useState(null);
  useEffect(() => {
    api.get(publico ? `/public/notizie/${id}` : `/notizie/interne/${id}`).then((r) => setN(r.data)).catch(() => setN(false));
  }, [id, publico]);
  const foto = n && ((publico ? n.foto && `${process.env.REACT_APP_BACKEND_URL}${n.foto}` : n.foto_id && fileUrl(n.foto_id)) || "/news-default.jpg");
  return (
    <article className="max-w-3xl">
      <Link to={publico ? "/associazione#news" : "/notizie"} className="inline-flex items-center gap-1 text-sm text-emerald-700 hover:underline mb-6" data-testid="news-back-link">
        <ArrowLeft className="h-4 w-4" />{publico ? "Torna alla pagina iniziale" : "Tutte le news"}
      </Link>
      {n === false && <Empty data-testid="news-not-found">Notizia non trovata.</Empty>}
      {n && (
        <div className="fade-up" data-testid="news-detail">
          <div className="text-xs font-mono-x uppercase tracking-wider text-muted-foreground">{fmtDate(n.data)} · {n.autore}</div>
          <h1 className="font-heading text-4xl sm:text-5xl font-bold uppercase text-[#0B192C] mt-2 mb-6" data-testid="news-detail-title">{n.titolo}</h1>
          {foto && <img src={foto} alt={n.titolo} className="w-full max-h-[460px] object-cover rounded-2xl mb-8" data-testid="news-detail-photo" />}
          <RichText html={n.testo} data-testid="news-detail-text" />
          {n.allegato && <Allegato href={`${process.env.REACT_APP_BACKEND_URL}${n.allegato}`} nome={n.allegato_nome} testid="news-detail-attachment" />}
          <ShareButtons id={n.id} title={n.titolo} />
        </div>
      )}
    </article>
  );
}
